<div class="modal-backdrop">
  <div class="modal-panel" role="dialog" aria-modal="true" aria-labelledby="insolvency-title">
    <div class="modal-header">
      <h2 id="insolvency-title">{{ 'insolvencyModal.title' | t }}</h2>
      <button type="button" class="modal-close-btn" (click)="close.emit()"
        [attr.aria-label]="'modalCommon.closeAria' | t">&times;</button>
    </div>
    <div class="modal-body">
        <p class="modal-intro">{{ 'insolvencyModal.intro' | t }}</p>
        @if (showDevHelper) {
          <div class="dev-helper-box" role="note">
            <div class="dev-helper-head">{{ 'modalCommon.devDataTitle' | t }}</div>
            <button type="button" class="btn-dev-fill" (click)="insertTestData()">
              {{ 'modalCommon.insertTestData' | t }}
            </button>
          </div>
        }
      <form id="insolvency-form" (ngSubmit)="onSubmit()" novalidate>
        @for (field of fields; track field) {
          <div class="form-group">
            <label [for]="'insolvency-' + field">{{ ('insolvencyModal.' + field) | t }}
              @if (field === 'email') { <span aria-hidden="true">*</span> }
            </label>
            @if (field === 'procedure_status') {
              <select [id]="'insolvency-' + field" [name]="field"
                [ngModel]="values()[field] ?? ''" (ngModelChange)="setValue(field, $event)">
                <option value="">{{ 'insolvencyModal.statusPlaceholder' | t }}</option>
                @for (status of ['yes', 'no', 'unknown']; track status) {
                  <option [value]="status">{{ ('insolvencyModal.status.' + status) | t }}</option>
                }
              </select>
            } @else {
            <input [id]="'insolvency-' + field" [name]="field" [required]="field === 'email'"
              [type]="field === 'email' ? 'email' : field === 'telefon' ? 'tel' : 'text'"
              [attr.autocomplete]="field === 'email' ? 'email' : field === 'telefon' ? 'tel' : 'off'"
              maxlength="120" [ngModel]="values()[field] ?? ''" (ngModelChange)="setValue(field, $event)" />
            }
          </div>
        }
        @if (submitAttempted() && !isValid()) {
          <p class="field-error" role="alert">{{ 'insolvencyModal.invalid' | t }}</p>
        }
      </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="close.emit()">{{ 'common.cancel' | t }}</button>
        <button type="submit" form="insolvency-form" class="btn-submit">{{ 'common.submit' | t }}</button>
    </div>
  </div>
</div>
